<template>
  <div id="live-streaming">
    <div id="fullscreen_elem" class="livewrap">
      <div class="livewrap__inner">
        <div class="columns">
          <div class="column video__outer">
            <div class="account" v-if="performerId != undefined">
              <router-link
                class="account__link__wrap"
                :to="`/castinfo/${performerId}`"
              >
                <div class="account__thumbnail">
                  <b-image class="icon" :src="photoURL" alt="" :rounded="true" ratio="1by1"/>
                </div>
                <div class="account__name">
                  {{ performerName }}
                </div>
              </router-link>
            </div>
            <div class="video individual" v-if="mode == MODE.INDIVIDUAL">
              <div class="video__wrap">
                <div class="video__wrap__inner">
                  <IndividualVideo :thumbnailURL="thumbnailURL" v-on:device-info="setChimeDeviceInfo" ref="individualVideo"/>
                </div>
              </div>
              <div class="video__setting" v-if="isShowSetting">
                <div class="video__setting__content">
                  <div v-if="settingInfo && settingInfo.type == 'meeting'">
                    <p class="setting_name">マイク</p>
                    <div class="setting_item" v-for="(item, index) in settingInfo.audioInputDevices" :key="`s1-${index}`" :value="item" @click="selectAudioInputDevice(item)">
                      <span>{{ item.deviceId == selectedDeviceId.audioInputDevice ? '⚫︎' : ' ' }}</span>{{ item.label }}
                    </div>
                    <br/>
                    <p class="setting_name">スピーカー</p>
                    <div class="setting_item" v-for="(item, index) in settingInfo.audioOutputDevices" :key="`s2-${index}`" :value="item" @click="selectAudioOutputDevice(item)">
                      <span>{{ item.deviceId == selectedDeviceId.audioOutputDevice ? '⚫︎' : ' ' }}</span>{{ item.label }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="video__control">
                <div class="video__control__group">
                  <div class="video__control__group__setting" @click="isShowSetting = !isShowSetting">
                    <img class="is-hidden-desktop" :src="require(`../assets/image/controller/${isFullscreen ? 'fullscreen' : 'window'}/individual/sp/btn_setting.png`)" alt=""/>
                    <img class="is-hidden-touch" :src="require(`../assets/image/controller/${isFullscreen ? 'fullscreen' : 'window'}/individual/pc/btn_setting.png`)" alt=""/>
                  </div>
                  <div class="video__control__group__switch__mic" @click="switchUseMic">
                    <img class="is-hidden-desktop" :src="require(`../assets/image/controller/${isFullscreen ? 'fullscreen' : 'window'}/individual/sp/btn_mic_${isUseMic ? 'on' : 'off'}.png`)" alt=""/>
                    <img class="is-hidden-touch" :src="require(`../assets/image/controller/${isFullscreen ? 'fullscreen' : 'window'}/individual/pc/btn_mic_${isUseMic ? 'on' : 'off'}.png`)" alt=""/>
                  </div>
                  <div class="video__control__group__switch__fullscreen" @click="switchFullscreen">
                    <img class="is-hidden-desktop" :src="require(`../assets/image/controller/${isFullscreen ? 'fullscreen' : 'window'}/individual/sp/btn_switcher.png`)" alt=""/>
                    <img class="is-hidden-touch" :src="require(`../assets/image/controller/${isFullscreen ? 'fullscreen' : 'window'}/individual/pc/btn_switcher.png`)" alt=""/>
                  </div>
                </div>
                <b-button
                  @click="onClickSendGift"
                  rounded
                  expanded
                  :disabled="!isRecentLive"
                  ><span>プレゼントを贈る</span></b-button>
              </div>
            </div>
            <div class="video open" v-if="mode == MODE.OPEN">
              <div class="video__wrap">
                <div class="video__wrap__inner">
                  <OpenVideo :liveUrl="playbackUrl" :thumbnailURL="thumbnailURL" ref="openVideo"/>
                </div>
              </div>
              <div class="video__control">
                <div class="video__control__group">
                  <div class="video__control__group__switch__speaker" @click="switchUseSpeaker">
                    <img class="is-hidden-desktop" :src="require(`../assets/image/controller/${isFullscreen ? 'fullscreen' : 'window'}/open/sp/btn_speaker_${isUseSpeaker ? 'on' : 'off'}.png`)" alt=""/>
                    <img class="is-hidden-touch" :src="require(`../assets/image/controller/${isFullscreen ? 'fullscreen' : 'window'}/open/pc/btn_speaker_${isUseSpeaker ? 'on' : 'off'}.png`)" alt=""/>
                  </div>
                  <div class="video__control__group__switch__fullscreen" @click="switchFullscreen">
                    <img class="is-hidden-desktop" :src="require(`../assets/image/controller/${isFullscreen ? 'fullscreen' : 'window'}/open/sp/btn_switcher.png`)" alt=""/>
                    <img class="is-hidden-touch" :src="require(`../assets/image/controller/${isFullscreen ? 'fullscreen' : 'window'}/open/pc/btn_switcher.png`)" alt=""/>
                  </div>
                </div>
                <b-button
                  @click="onClickSendGift"
                  rounded
                  expanded
                  v-if="isRecentLive"
                  ><span>プレゼントを贈る</span></b-button>
              </div>
            </div>
            <div class="video upcoming" v-if="mode == MODE.UPCOMING || mode == MODE.INDIVIDUAL_WAITING">
              <img :src="thumbnailURL" alt=""/>
              <div class="upcoming__wrap"><p>{{ mode == MODE.UPCOMING ? "勇者様、ただいま開店準備中でございます。少々お待ちくださいませ。" : "勇者様、キャストは現在別の席についております。準備が整うまでお待ちくださいませ。" }}</p></div>
            </div>
            <div class="fullscreen_control" @click="onClickSendGift">
              <img class="is-hidden-desktop" :src="require(`../assets/image/controller/fullscreen/open/sp/btn_present.png`)" alt=""/>
              <img class="is-hidden-touch" :src="require(`../assets/image/controller/fullscreen/open/pc/btn_present.png`)" alt=""/>
            </div>
            <div class="video pause" v-if="mode == MODE.PAUSE">
              <div class="video__wrap">
                <div class="video__wrap__inner">
                </div>
              </div>
            </div>
            <div class="information">
              <div class="information__title">{{ title }}</div>
              <div class="information__data" v-if="isRecentLive && mode == MODE.OPEN">{{patronCount}}人が視聴中 ライブ配信開始：{{ startDatetime }}</div>
            </div>
          </div>
          <div class="column video__text">
            <Chat ref="chat" :params="chatParams"/>
          </div>
        </div>
        <ReserveList :liveId="liveId" :castName="performerName" :castId="performerId" />
        <div class="cast cast--online" v-if="liveCastList.length > 0">
          <div class="cast__header">
            <div class="cast__header__comment">配信中のキャスト</div>
            <button v-if="!isCast" class="cast__header__button" @click="() => $router.push({ path: '/live/explore' })">出勤表</button>
          </div>
          <ul class="cast__list">
            <li class="cast__item" v-for="cast in liveCastList" :key="cast.id">
              <div class="cast__image">
                <router-link :to="`/live/streaming/${cast.liveId}?type=${cast.liveType}`">
                  <img :src="cast.photoURL" alt="">
                </router-link>
              </div>
              <div class="cast__name">{{ cast.nickname }}</div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OpenVideo from '@/components/Video';
import IndividualVideo from '@/components/ChimeVideo';
import Chat from '@/components/Chat';
import moment from 'moment';
import LiveStreamingSendGiftModal from '@/components/LiveStreamingSendGiftModal';
import ReserveList from '@/components/ReserveList';
import * as userServices from '@/services/userServices';
import * as doronServices from '@/services/doronServices';
import * as authServices from '@/services/authServices';
import * as freeLiveCheckServices from '@/services/freeLiveCheckServices';
import { USER_VIEW_STATUS, checkUserViewStatus, getCastListWithTodayLive } from '@/services/liveServices';
import { mapState } from 'vuex';
import { firebase, auth } from '@/plugins/firebase';
import * as modal from '@/utils/modal';
import { analyticsLog } from '@/utils/analytics';
import { fullscreen } from '@/utils/screen';

const functions = firebase.app().functions('asia-northeast1');

const FREE_VIEW_CHECK_INTERVAL = 5000;
const FREE_VIEW_PERIOD = 600;
const OPEN_PRICE = 300;

const MODE = {
  UPCOMING: "upcoming",
  OPEN: "open",
  INDIVIDUAL: "individual",
  INDIVIDUAL_WAITING: "individual_waiting",
  PAUSE: "pause"
}

export default {
  name: 'LiveStreaming',
  components: {
    OpenVideo,
    IndividualVideo,
    Chat,
    ReserveList
  },
  data() {
    return {
      MODE: MODE,
      mode: null,
      liked: false,
      comment: '',
      comments: [],
      sendedGifts: [],
      commentRefObj: {},
      liveCastList: [],
      item: {},
      isRecentLive: true,
      isShowSetting: false,
      isUseCamera: true,
      isUseMic: true,
      isUseSpeaker: true,
      settingInfo: null,
      patronCount: 0,
      createSendedGiftsTimerID: null,
      checkLiveTimerID: null,
      checkSigninDateTimeTimerID: null,
      checkViewStatusID: null,
      getStreamIntervalID: null,
      selectedDeviceId: {
        audioInputDevice: null,
        audioOutputDevice: null
      },
      paramCastId: null,
      tmpCastId: null,
      isFullscreen: false
    };
  },
  computed: {
    ...mapState({
      uid: state => state.auth.uid,
      startAt: state => state.live.upComingLive.startAt
    }),
    liveId() {
      return this.$route.params.liveId;
    },
    nowReserveId() {
      return this.$store.state.live.recentLive.nowReserveId;
    },
    chatParams() {
      return {
        liveId: this.nowReserveId ? this.liveId + "_" + this.nowReserveId : this.liveId,
        myPhotoURL: this.myPhotoURL,
        isRecentLive: this.isRecentLive,
        commentDisabled: this.mode == MODE.UPCOMING || this.mode == MODE.INDIVIDUAL_WAITING
      }
    },
    playbackUrl() {
      return this.$store.getters['live/playbackUrl'];
    },
    defaultPhotoURL() {
      return 'https://firebasestorage.googleapis.com/v0/b/pandora-988f8.appspot.com/o/all%2Fdefault-user-icon.png?alt=media&token=4a1a4307-1990-4c99-a944-9b8d289e1a50';
    },
    photoURL() {
      const liveDoc = this.isRecentLive
        ? this.$store.state.live.recentLive
        : this.$store.state.live.upComingLive;
      return liveDoc.performerPhotoURL
        ? liveDoc.performerPhotoURL
        : this.defaultPhotoURL;
    },
    myPhotoURL() {
      return this.$store.state.user.photoURL || this.defaultPhotoURL;
    },
    performerId() {
      return this.isRecentLive
        ? this.$store.state.live.recentLive.performerId
        : this.$store.state.live.upComingLive.performerId;
    },
    performerName() {
      return this.isRecentLive
        ? this.$store.state.live.recentLive.performerName
        : this.$store.state.live.upComingLive.performerName;
    },
    title() {
      return this.isRecentLive
        ? this.$store.state.live.recentLive.title
        : this.$store.state.live.upComingLive.title;
    },
    startDatetime() {
      var timestamp = this.isRecentLive
        ? this.$store.state.live.recentLive.startAt
        : this.$store.state.live.upComingLive.startAt;
      return timestamp ? moment.unix(timestamp.seconds).format('YYYY/MM/DD HH:mm') : "";
    },
    thumbnailURL() {
      if (this.$route.query.type == 'upComingLive') {
        return this.$store.state.live.upComingLive.thumbnailURL;
      } else if (this.$route.query.type == 'recentLive') {
        return this.$store.state.live.recentLive.thumbnailURL;
      }
      return '';
    }
  },
  watch: {
    $route () {
      location.reload()
    }
  },
  async created() {
    document.addEventListener("fullscreenchange", this.fullscreenchanged);

    if (!this.$route.params.liveId) {
      this.$router.replace(`/live/expired/${this.performerId}`);
      return;
    }

    if (this.$route.query.type == 'upComingLive') {

      this.isRecentLive = false;
      this.mode = MODE.UPCOMING;

      await this.checkUpComingLive();
      this.checkLiveTimerID = setInterval(async () => {
        await this.checkUpComingLive();
      }, 10000);
      return;
    } else {
      await this.checkReserveLive();
      this.checkLiveTimerID = setInterval(async () => {
        await this.checkReserveLive();
      }, 10000);
      await this.checkViewStatus(true);
    }

    this.liked = this.$store.state.user.likedPerformers
      .map(p => p.userId)
      .includes(this.$store.state.live.recentLive.performerId);

    this.createSendedGiftsTimerID = setInterval(async () => {
      this.createSendedGifts();
    }, 1000);

    this.checkSigninDateTimeTimerID = setInterval(async () => {
      this.checkSigninDateTime();
    }, 60000);

    this.paramCastId = this.performerId;
    analyticsLog('視聴画面【表示時】', {'キャストID': this.performerId});
  },
  methods: {
    async checkUpComingLive() {
      await this.$store.dispatch('live/loadUpComingLive', this.$route.params.liveId);

      if (!this.$store.state.live.upComingLive) {
        await this.$store.dispatch('live/loadRecentLive', this.$route.params.liveId);

        if (this.$store.state.live.recentLive) {
          this.$router.push(`/live/streaming/${this.$route.params.liveId}?type=recentLive`);
        } else {
          this.$router.replace(`/live/expired/${this.paramCastId}`);
        }
      }
    },
    async readLiveCastList() {
      var data = await getCastListWithTodayLive();
      this.liveCastList = data.filter(cast => {
        return cast.liveId != this.$route.params.liveId;
      });
    },
    async checkReserveLive() {
      if (this.mode == MODE.PAUSE) {
        return;
      }
      this.readLiveCastList();

      await this.$store.dispatch('live/loadRecentLive', this.$route.params.liveId);

      if (!this.$store.state.live.recentLive) {
        this.$router.replace(`/live/expired/${this.paramCastId}`);
        return;
      }

      this.tmpCastId = this.performerId;

      await this.$store.dispatch('checkReserveLive', {
        liveId: this.$route.params.liveId,
        nowReserveId: this.$store.state.live.recentLive.nowReserveId
      });

      if (this.$store.state.live.reserveLive && this.$store.state.live.reserveLive.reserver) {
        if (this.$store.state.live.reserveLive.reserver == this.$store.state.auth.uid) {
          if (this.mode != MODE.INDIVIDUAL) {
            await this.loadComment();
            setTimeout(async () => {
              if (this.$refs.individualVideo) await this.$refs.individualVideo.startMeeting();
            }, 1000);
          }
          this.mode = MODE.INDIVIDUAL;
          if (this.checkViewStatusID) {
            clearTimeout(this.checkViewStatusID);
            this.checkViewStatusID = null;
          }
        } else {
          this.mode = MODE.INDIVIDUAL_WAITING;
          this.commentRefObj = {};
        }
      } else {
        if (this.mode == MODE.INDIVIDUAL) {
          await this.$store.dispatch('doron/loadDoronDoc', this.$store.state.auth.uid);
        }
        if (this.mode == MODE.INDIVIDUAL || this.mode == MODE.INDIVIDUAL_WAITING) {
          this.checkViewStatus(true);
        }
        if (this.mode != MODE.OPEN) {
          var userId = this.performerId;
          var user = await userServices.getUserDoc(userId);
          if (user) {
            this.getStream(user.ivsChannelArn);
            this.getStreamIntervalID = setInterval(async () => {
              await this.getStream(user.ivsChannelArn);
            }, 3000);
          }
          await this.$refs.chat.enterUser();
          setTimeout(async () => {
            await this.loadComment();
          }, 1000)
        }
        this.mode = MODE.OPEN;
      }
    },
    scrollToEnd() {
      const container = document.querySelector('.comment__display');
      container.scrollTop = container.scrollHeight;
    },
    createSendedGifts() {
      var sendedGifts = [];

      this.comments.forEach(item => {
        if (item.type == "gift"
          && item.period
          && moment().unix() <= item.period) {
          sendedGifts.unshift(item);
        }
      });

      this.sendedGifts = this.sortSendedGifts(sendedGifts)
      if (this.$refs.giftHistory) this.$refs.giftHistory.setGifts(this.sendedGifts);
    },
    sortSendedGifts(sendedGifts) {
      if (!sendedGifts) {
        return [];
      }

      sendedGifts.sort((itemA, itemB) => {
        if (itemA.isPaid != itemB.isPaid) {
          return itemA.isPaid < itemB.isPaid ? 1 : -1;
        }
        if (itemA.price != itemB.price) {
          return itemA.price < itemB.price ? 1 : -1;
        }
        if (itemA.timestamp != itemB.timestamp) {
          return itemA.timestamp < itemB.timestamp ? 1 : -1;
        }
        return 0;
      });

      if (sendedGifts.length > 10) sendedGifts = sendedGifts.slice(0, 10);
      return sendedGifts;
    },
    onClickSendGift() {
      const self = this;
      this.$buefy.modal.open({
        parent: this,
        component: LiveStreamingSendGiftModal,
        hasModalCard: true,
        trapFocus: true,
        canCancel: false,
        props: {
          mode: this.mode == MODE.INDIVIDUAL ? MODE.INDIVIDUAL : MODE.OPEN,
          liveId: this.liveId,
          castId: this.performerId,
        },
        events: {
          setCommentPayload(payload) {
            analyticsLog('プレゼント投稿完了【動作完了】', {'プレゼントID': payload.giftId});
            if (payload.withAnimation) self.dispGiftEffect(payload.giftId);
            let newMessageRef = self.commentRefObj.push();
            newMessageRef.set(payload);
          }
        }
      });
    },
    dispGiftEffect(giftId) {
      const h = this.$createElement
      const vnode = h('p', {}, [
        h('img', { class: "is-hidden-touch gift-image", attrs: { src: require(`../assets/image/gifts/effects/${giftId}_pc.gif`) }}),
        h('img', { class: "is-hidden-desktop gift-image", attrs: { src: require(`../assets/image/gifts/effects/${giftId}_sp.gif`) }}),
      ])
      var modal = this.$buefy.modal.open({
        parent: this,
        content: [ vnode ],
        hasModalCard: true,
        trapFocus: true,
        canCancel: false,
        props: {
        },
        events: {
        }
      });

      setTimeout(() => {
        modal.close();
      }, 3000);
    },
    async onClickLike() {
      try {
        if (!this.liked) {
          const payload = {
            userId: this.$store.state.auth.uid,
            performerId: this.performerId
          };
          await this.$store.dispatch('user/addPerformerToLiked', payload);
          this.liked = true;
        } else {
          const payload = {
            userId: this.$store.state.auth.uid,
            performerId: this.performerId
          };
          await this.$store.dispatch('user/removePerformerFromLiked', payload);
          this.liked = false;
        }
      } catch (err) {
        console.error(err);
        throw err;
      }
    },
    async loadComment() {
      this.commentRefObj = await this.$refs.chat.readComment();
    },
    async onClickComment() {
      if (this.comment == '') return;
      const payload = {
        userId: this.$store.state.auth.uid,
        nickname: this.$store.state.user.nickname,
        photoURL: this.$store.state.user.photoURL,
        message: this.comment,
        type: 'comment',
        timestamp: moment().unix()
      };
      this.comment = '';
      let newMessageRef = this.commentRefObj.push();
      newMessageRef.set(payload);
    },
    findImage(img) {
      return img ? img : this.defaultPhotoURL;
    },
    setChimeDeviceInfo(devices) {
      var audioInputDevices = [];
      devices.audioInputDevices.forEach(item => {
        if (item.deviceId != 'default') {
          audioInputDevices.push(item);
        }
      });
 
      var audioOutputDevices = [];
      devices.audioOutputDevices.forEach(item => {
        if (item.deviceId != 'default') {
          audioOutputDevices.push(item);
        }
      });

      if (this.$refs.individualVideo) {
        this.selectedDeviceId.audioInputDevice = this.$refs.individualVideo.findDefaultDeviceId(devices.audioInputDevices);
        this.selectedDeviceId.audioOutputDevice = this.$refs.individualVideo.findDefaultDeviceId(devices.audioOutputDevices);
      }

      this.settingInfo = {
        type: 'meeting',
        audioInputDevices: audioInputDevices,
        audioOutputDevices: audioOutputDevices
      }
    },
    async getStream(channelArn) {
      if (!channelArn) return;
      const getStream = functions.httpsCallable('getStream');
      const response = await getStream({
        channelArn: channelArn
      });
      if (response.data.httpErrorCode) return;
      this.patronCount = response.data.viewerCount > 0 ? response.data.viewerCount - 1 : 0;
    },
    async selectAudioInputDevice(item) {
      if (item.selected) {
        return;
      }
      if (this.$refs.individualVideo) {
        await this.$refs.individualVideo.chooseAudioInputDevice(item.deviceId);
        this.selectedDeviceId.audioInputDevice = item.deviceId;
      }
    },
    async selectAudioOutputDevice(item) {
      if (item.selected) {
        return;
      }
      if (this.$refs.individualVideo) {
        await this.$refs.individualVideo.chooseAudioOutputDevice(item.deviceId);
        this.selectedDeviceId.audioOutputDevice = item.deviceId;
      }
    },
    async checkViewStatus(isCreated = false) {
      let result = await checkUserViewStatus(this.$route.params.liveId, this.$store.state.auth.uid);

      if (result == USER_VIEW_STATUS.NOTFOUND) {
        return;
      }

      if (result == USER_VIEW_STATUS.PAID) {
        if (this.checkViewStatusID) {
          clearTimeout(this.checkViewStatusID);
          this.checkViewStatusID = null;
        }
      }

      if (result == USER_VIEW_STATUS.PAID || this.mode != MODE.OPEN) {
        return;
      }

      if (result == USER_VIEW_STATUS.NONE) {
        modal.alert(this, "", "フリー配信は10分間無料視聴可能です。以降は300Gで最後まで視聴可能です。※視聴ページを離れている時間、及び限定配信中の時間はカウントされません。", async () => {
          await this.$store.dispatch('startFreeView', {
            liveId: this.$route.params.liveId,
            userId: this.$store.state.auth.uid
          });
          this.checkViewStatusID = setInterval(() => {
            this.checkViewStatus();
          }, FREE_VIEW_CHECK_INTERVAL)
        });
        return;
      }

      if (result == USER_VIEW_STATUS.FREE) {
        let data = await freeLiveCheckServices.countUp(this.$store.state.auth.uid, this.$route.params.liveId, Math.round(FREE_VIEW_CHECK_INTERVAL / 1000));
        if (data.count < FREE_VIEW_PERIOD) {
          if (isCreated) {
            this.checkViewStatusID = setInterval(() => {
              this.checkViewStatus();
            }, FREE_VIEW_CHECK_INTERVAL)
          } 
          return;
        }

        let nowMode = this.mode;
        this.mode = MODE.PAUSE;
        modal.confirm(this, "", `以降の視聴には${OPEN_PRICE}G使用します。Gは無償Gが優先して使用されます。`, async () => {
          this.$router.push({name: '/home', hash: '#castlist'});
        }, async () => {
          await this.payOpenStreaming(nowMode);
        });
        return;
      }

    },
    async payOpenStreaming(nowMode) {
      if (this.checkViewStatusID) {
        clearTimeout(this.checkViewStatusID);
        this.checkViewStatusID = null;
      }
      let payload = {
        doronType: 'freeDoron',
        price: OPEN_PRICE
      }
      let freeDoron = this.$store.getters['doron/freeDoronAmount'];
      if (freeDoron < 300) {
        payload.doronType = 'doron';
        let doron = this.$store.getters['doron/doronAmount'];
        if (doron < 300) {
          modal.openPointLackModal(this, "Gが不足しています。購入ページよりご購入下さい。", async () => {
            this.mode = nowMode;
            await this.checkViewStatus();
          });
          return;
        }
      }

      // purchase item
      await this.$store.dispatch('doron/purchaseItem', payload);
      await doronServices.addPurchaseHistory(doronServices.PURCHASE_KIND.OPEN_LIVE, this.$store.state.auth.uid, this.tmpCastId, this.liveId, payload.doronType, payload.price);

      await this.$store.dispatch('startPaidView', {
        liveId: this.$route.params.liveId,
        userId: this.$store.state.auth.uid
      });
      this.mode = nowMode;
    },
    switchUseMic() {
      this.isUseMic = !this.isUseMic;
      this.$refs.individualVideo.switchMute(!this.isUseMic);
    },
    switchUseSpeaker() {
      this.isUseSpeaker = !this.isUseSpeaker;
      this.$refs.openVideo.switchSpeaker(this.isUseSpeaker);
    },
    async checkSigninDateTime() {
      if (!(await authServices.checkSigninDateTime())) {
        await auth.signOut().catch(err => {
          console.error(err);
        });
        await this.$store.dispatch('live/initStore');
        this.$store.dispatch('auth/signOut');
        this.$router.push({ path: '/signin', force: true });
      }
    },
    fullscreenchanged() {
      this.isFullscreen = document.fullscreenElement ? true : false;
      this.changeFullscreen();
    }, 
    switchFullscreen() {
      if (!fullscreen(document.body, !this.isFullscreen)) {
        this.isFullscreen = !this.isFullscreen;
        this.changeFullscreen();
      }
    },
    changeFullscreen() {
      let elem = document.getElementById('fullscreen_elem');
      if (this.isFullscreen) {
        elem.classList.add("fullscreen");
      } else {
        elem.classList.remove("fullscreen");
      }
    }
  },
  beforeDestroy() {
    document.removeEventListener("fullscreenchange", this.fullscreenchanged);
    if (this.createSendedGiftsTimerID) {
      clearInterval(this.createSendedGiftsTimerID);
      this.createSendedGiftsTimerID = null;
    }
    if (this.checkLiveTimerID) {
      clearInterval(this.checkLiveTimerID);
      this.checkLiveTimerID = null;
    }
    if (this.checkSigninDateTimeTimerID) {
      clearInterval(this.checkSigninDateTimeTimerID);
      this.checkSigninDateTimeTimerID = null;
    }
    if (this.checkViewStatusID) {
      clearTimeout(this.checkViewStatusID);
      this.checkViewStatusID = null;
    }
    if (this.getStreamIntervalID) {
      clearTimeout(this.getStreamIntervalID);
      this.getStreamIntervalID = null;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../assets/scss/live-streaming.scss';
</style>

<style lang="scss">
@import '../assets/scss/live-streaming-fullscreen.scss';
</style>

<style lang="scss">
.gift-image {
  position: relative;
}
</style>
